export function constructIntlErrorMessage(
  formatMessage,
  messageIds = ['THERE_WAS_A_PROBLEM', 'PLEASE_TRY_AGAIN'],
  template = '{0}. {1}.'
) {
  let errorMessage = template;
  messageIds.forEach((id, index) => {
    const message = formatMessage({ id });
    errorMessage = errorMessage.replace(`{${index}}`, message);
  });
  return errorMessage;
}



// WEBPACK FOOTER //
// ./src/helpers/constructIntlErrorMessage.js